import {createAction} from '@reduxjs/toolkit'
import {Interaction} from '../services/logger'
import {createAsyncAction} from '../services/redux-toolkit'

export const detailsPageLoaded = createAction('DETAILS_PAGE_LOADED')

export const thankYouPageLoaded = createAction('THANK_YOU_PAGE_LOADED')

export const ticketedThankYouPageLoaded = createAction('TICKETED_THANK_YOU_PAGE_LOADED')

export const formPageLoaded = createAsyncAction('FORM_PAGE_LOADED', async (checkout: boolean, {extra: {logger}}) => {
  if (checkout) {
    logger.finishInteraction(Interaction.CreateReservation)
  }
})
